export const SET_FOOTER_DATA = "SET_FOOTER_DATA";
export const SET_NEWS_LETTER_SUBSCRIPTION_DATA =
  "SET_NEWS_LETTER_SUBSCRIPTION_DATA";
export const RESET_NEWS_LETTER_SUBSCRIPTION_DATA =
  "RESET_NEWS_LETTER_SUBSCRIPTION_DATA";
